import { createContext } from 'react';
import { DealFinderStore } from '../Storage/DealFinderStore';

const DealFinderContext = createContext(new DealFinderStore());
export default DealFinderContext;
